module.exports = __webpack_public_path__ + "media/video.d8065bea.mp4";